var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgObjectOutsideIcon = function SvgObjectOutsideIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    style: {
      transform: "scale(1.5)"
    },
    viewBox: "64 64 896 896"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    style: {
      transform: "scale(25)"
    },
    transform: "translate(3 7)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 15.75,
    x: 5.75,
    y: 4.5,
    rx: 2.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    d: "m-1.39 2.72 2.451-3.773 33.967 22.057-2.451 3.774z"
  }))));
};
export default SvgObjectOutsideIcon;